"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _base = _interopRequireDefault(require("./base"));
var _log = _interopRequireDefault(require("../utils/log"));
var _legoVisitOrderTracking = _interopRequireDefault(require("../plugins/lego-visit-order-tracking"));
var _legoVisitStackTracking = _interopRequireDefault(require("../plugins/lego-visit-stack-tracking"));
var _legoUserStayTime = _interopRequireDefault(require("../plugins/lego-user-stay-time"));
var _legoClosemarkByPageid = _interopRequireDefault(require("../plugins/lego-closemark-by-pageid"));
var legoInit = function legoInit() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    log: false
  };
  try {
    // init基础版本
    (0, _base.default)(params);
    // 根据参数默认开启的插件
    (0, _legoVisitOrderTracking.default)(params, legoInit); // 自动埋点逻辑初始化
    (0, _legoVisitStackTracking.default)(); // 初始化页面展现钩子逻辑
    // 开启统计页面停留时长功能
    if (params.routeList && params.stayUserTime) {
      try {
        (0, _legoUserStayTime.default)();
      } catch (err) {
        _log.default.error("\u5F00\u542F\u7EDF\u8BA1\u9875\u9762\u505C\u7559\u65F6\u957F\u529F\u80FD\u51FA\u9519".concat(err));
      }
    }
    // init中开启setCloseMark，会默认使用pageId为每个页面设置 setCloseMark
    if (params.routeList && params.setCloseMark) {
      try {
        (0, _legoClosemarkByPageid.default)();
      } catch (err) {
        _log.default.error("\u5F00\u542F\u9875\u9762\u81EA\u52A8setCloseMark\u51FA\u9519".concat(err));
      }
    }
  } catch (err) {
    _log.default.error(err);
  }
};
legoInit.resumePV = function () {};
legoInit.userBackup = {};
legoInit.getUserBackup = function () {
  return legoInit.userBackup;
};
legoInit.setUserBackup = function (param) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (param) {
    legoInit.userBackup = Object.assign({}, legoInit.userBackup, param);
    if (opts.isAllData) {
      window['zz_lego_backup'] = Object.assign({}, window['zz_lego_backup'], this.userBackup);
    }
    legoInit.userBackup.pagequery && (window['zz_lego_backup'].pagequery = legoInit.userBackup.pagequery);
    legoInit.userBackup.subpageID && (window['zz_lego_backup'].subpageID = legoInit.userBackup.subpageID);
    legoInit.userBackup.postid && (window['zz_lego_backup'].postid = legoInit.userBackup.postid);
    legoInit.userBackup.ABContent && (window['zz_lego_backup'].ABContent = legoInit.userBackup.ABContent);
    legoInit.userBackup.mchannel && (window['zz_lego_backup'].mchannel = legoInit.userBackup.mchannel);
  }
};
var _default = legoInit;
exports.default = _default;